import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { StockStatus } from '@models/api-search.models';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-stock-status',
    templateUrl: './stock-status.component.html',
    styleUrls: ['./stock-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass]
})
export class StockStatusComponent {
    @Input()
    status: StockStatus = 'InStock';
}
